import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function OfferBlock() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} id="get-protocol" className="w-full bg-[#F0F5EE] py-10 md:py-16 px-4" data-id="element-118">
      <div className="max-w-2xl mx-auto text-center" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} data-id="element-120">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl font-bold text-[#2D4A3E] mb-3" data-id="element-121">
            Reclaim Your Evenings
          </h2>
          <p className="font-['Source_Sans_3'] text-lg md:text-xl text-[#3A3A3A] mb-6" data-id="element-122">
            Stop the mealtime exhaustion for less than the cost of a single
            takeout meal.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-[#E8DDD0] mb-8" data-id="element-123">
            <p className="font-['Playfair_Display'] text-xl md:text-2xl font-semibold text-[#2D4A3E] mb-4" data-id="element-124">
              The Picky Eater's "Peace at Dinner" Protocol
            </p>
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-125">
              <span className="font-['Playfair_Display'] text-2xl md:text-3xl text-[#3A3A3A]/40 line-through" data-id="element-126">
                $19
              </span>
              <span className="font-['Playfair_Display'] text-5xl md:text-6xl font-bold text-[#2D4A3E]" data-id="element-127">
                $6.36
              </span>
            </div>

            <motion.a href="https://coresolutionsg.com/cart/47491565027515:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: 'Peace at Dinner Protocol',
                content_type: 'product',
                value: 6.36,
                currency: 'USD'
              });
            }
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block w-full md:w-auto bg-[#C4883A] hover:bg-[#A8712E] text-white font-semibold text-lg md:text-xl px-12 py-5 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl" data-id="element-128">
              GET THE PROTOCOL NOW
            </motion.a>

            <p className="mt-4 text-sm text-[#5B8A7A] font-medium" data-id="element-129">
              Instant PDF Access • No Physical Shipping Required
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="font-['Source_Sans_3'] text-[#5B8A7A] italic" data-id="element-130">
            Join hundreds of families who've ended the mealtime battle
          </motion.p>
        </motion.div>
      </div>
    </section>;
}